import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  ComponentRef, Injectable,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {DynamicModalAbstractComponent} from '../../../classes/dynamic-modal-abstract-component';
import {DynamicModalLoaderService} from '../../../services/dynamic-modal-loader.service';
import {IEService} from '@ispm/shared/services/IE.service';
import {EmitType} from '../../../constants/emit-types.enum';
import {ModalManagementService} from "@ispm/layout/services/modal-management.service";
import {forkJoin, Observable, Subject} from 'rxjs';
import {map, take} from "rxjs/operators";

@Component({
  selector: 'gen-placeholder-modal',
  templateUrl: './placeholder-modal.component.html',
  styleUrls: ['./placeholder-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class PlaceholderModalComponent extends DynamicModalAbstractComponent implements OnInit, OnDestroy {
  @ViewChild('target', {static: true, read: ViewContainerRef}) target;
  public cmpRef: ComponentRef<any>;
  public componentToLoad;
  public tunnel: Subject<any> = new Subject();
  public callback: any;
  public actionIcon: string;
  public content: string;
  public contentParams: string;
  public buttons: { declineBtn: string, approveBtn: string, actionBtn: string };
  public buttonsStatuses: { declineBtn: boolean, approveBtn: boolean, actionBtn: boolean, disableApproveBtnOnEmptyPayload: boolean };
  public editMode: boolean;
  public emitCancel: boolean;
  public additionalStyles: { heightAdjust: boolean, paddingZero: boolean } = {heightAdjust: false, paddingZero: false};

  constructor(
    modalLoaderService: DynamicModalLoaderService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private _ieService: IEService,
    private modalManagementService: ModalManagementService
  ) {
    super(modalLoaderService);
  }

  onNext(payload): void {
    this.componentToLoad = payload && payload['componentToLoad'];
    this.callback = payload && payload['approveCallback'];
    this.actionIcon = payload && payload['actionIcon'];
    this.buttons = payload && payload['buttons'] || {};
    this.buttonsStatuses = payload && payload['buttonsStatuses'] || {
      declineBtn: false,
      approveBtn: false,
      actionBtn: false,
      disableApproveBtnOnEmptyPayload : false
    };

    this.content = payload && payload['content'] || '';
    if (this.buttonsStatuses.disableApproveBtnOnEmptyPayload && !this.content) {
      this.modalManagementService.disableApproveButton();
    }
    this.contentParams = payload && payload['params'] || '';
    this.editMode = payload && payload['editMode'] !== undefined ? payload['editMode'] : true;
    this.emitCancel = payload && payload['emitCancel'] !== undefined ? payload['emitCancel'] : false;
    this.additionalStyles.heightAdjust = payload && payload['additionalStyles'] !== undefined && payload['additionalStyles']['heightAdjust'] !== undefined ? payload['additionalStyles']['heightAdjust'] : false;
    this.additionalStyles.paddingZero = payload && payload['additionalStyles'] !== undefined && payload['additionalStyles']['paddingZero'] !== undefined ? payload['additionalStyles']['paddingZero'] : false;

    if (this.componentToLoad) {
      const factory = this.componentFactoryResolver.resolveComponentFactory(this.componentToLoad);
      this.cmpRef = this.target.createComponent(factory);
      this.cmpRef.instance['tunnel$'] = this.tunnel;
      this.cmpRef.instance['callback'] = this.callback;
      this.cmpRef.instance['payload'] = payload && payload.payload;

      if (this._ieService.isIE()) {
        this.cmpRef.location.nativeElement.style.flex = '1 1 auto';
      }

      this.tunnel
        .asObservable()
        .filter(value => value.emitter !== 'parent')
        .subscribe(next => {
          switch (next.value) {
            case EmitType.Data:
              Object.assign(this.buttonsStatuses, next.payload);
              break;
            default:
              this.close({data: next.value, status: EmitType.Dismiss, payload: next.payload});
              break;
          }
        });
    }
  }

  ngDoCheck() {
    if (this.buttonsStatuses.disableApproveBtnOnEmptyPayload && this.cmpRef.instance['payload']) {
      if (this.cmpRef.instance['payload']['text'] !== '') {
        this.modalManagementService.enableApproveButton();
      } else {
        this.modalManagementService.disableApproveButton();
      }
    }
  }

  onError(error): void {
  }

  onComplete(): void {
  }

  actionEmitter(value = true) {
    this.tunnel.next({emitter: 'parent', value: value});
  }

  cancelActionEmitter(value = true) {
    if(this.emitCancel) {
      this.tunnel.next({emitter: 'parent', value: value});
    }
    this.closeModalLoader(value);
  }
//
  closeModalLoader(value) {
    this.modalManagementService.resetData();
    super.close(value);
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    if (this.cmpRef) {
      this.cmpRef.destroy();
      this.cmpRef = null;
    }

    if (this.tunnel) {
      this.tunnel.complete();
    }
    this.modalManagementService.enableApproveButton();
  }

  approveBtnIsDisabled$() {
    return forkJoin([
      this.modalManagementService.approveButtonIsDisabled(),
      Observable.of(!this.editMode)
    ]).pipe(map(resp => resp[0] || resp[1]), take(1));
  }
}
